


  
  

  var faAngleDown = {
    prefix: 'fausb',
    iconName: 'angle-down',
    icon: [
      512,
      512,
      [8964],
      'f107',
      
      'M448.3 146.8l-192 192-192-192-45.2 45.2 214.6 214.6c12.5 12.5 32.8 12.5 45.3 0L493.5 192 448.3 146.8z'
      
    ]
  };

  

  
  

  var faAngleLeft = {
    prefix: 'fausb',
    iconName: 'angle-left',
    icon: [
      320,
      512,
      [8249],
      'f104',
      
      'M269.7 64l-192 192 192 192-45.3 45.2-214.6-214.6c-12.5-12.5-12.5-32.8 0-45.3L224.5 18.7 269.7 64z'
      
    ]
  };

  

  
  

  var faAngleRight = {
    prefix: 'fausb',
    iconName: 'angle-right',
    icon: [
      320,
      512,
      [8250],
      'f105',
      
      'M51.2 448l192-192-192-192 45.2-45.2 214.6 214.6c12.5 12.5 12.5 32.8 0 45.3L96.5 493.3 51.2 448z'
      
    ]
  };

  

  
  

  var faAngleUp = {
    prefix: 'fausb',
    iconName: 'angle-up',
    icon: [
      512,
      512,
      [8963],
      'f106',
      
      'M448.3 365.3l-192-192-192 192-45.2-45.3 214.6-214.6c12.5-12.5 32.8-12.5 45.3 0L493.5 320 448.3 365.3z'
      
    ]
  };

  

  
  

  var faArrowLeft = {
    prefix: 'fausb',
    iconName: 'arrow-left',
    icon: [
      448,
      512,
      [8592],
      'f060',
      
      'M269.3 64l-160 160 338.8 0 0 64-338.8 0 160 160-45.3 45.3-214.6-214.6c-12.5-12.5-12.5-32.8 0-45.3L224 18.8 269.3 64z'
      
    ]
  };

  

  
  

  var faArrowRight = {
    prefix: 'fausb',
    iconName: 'arrow-right',
    icon: [
      448,
      512,
      [8594],
      'f061',
      
      'M178.8 448l160-160-338.7 0 0-64 338.7 0-160-160 45.2-45.3 214.6 214.6c12.5 12.5 12.5 32.8 0 45.3L224 493.2 178.8 448z'
      
    ]
  };

  

  
  

  var faBars = {
    prefix: 'fausb',
    iconName: 'bars',
    icon: [
      512,
      512,
      ["navicon"],
      'f0c9',
      
      'M512 128l-512 0 0-64 512 0 0 64zm0 320l-512 0 0-64 512 0 0 64zM480 288l-480 0 0-64 512 0 0 64-32 0z'
      
    ]
  };

  
    var faNavicon = faBars;
  

  
  

  var faCalendar = {
    prefix: 'fausb',
    iconName: 'calendar',
    icon: [
      448,
      512,
      [128197,128198],
      'f133',
      
      'M160 32l128 0 0-64 64 0 0 64 32 0c35.3 0 64 28.7 64 64l0 320-.3 6.5c-3.1 30.1-27 54.1-57.1 57.1l-6.5 .3-320 0-6.5-.3c-30.1-3.1-54.1-27-57.1-57.1L0 416 0 96C0 60.7 28.7 32 64 32l32 0 0-64 64 0 0 64zM64 220l0 196 320 0 0-196-320 0zm0-56l320 0 0-68-320 0 0 68z'
      
    ]
  };

  

  
  

  var faCartShopping = {
    prefix: 'fausb',
    iconName: 'cart-shopping',
    icon: [
      640,
      512,
      [128722,"shopping-cart"],
      'f07a',
      
      'M0 0L122.2 0c3 15.1 7.3 36.4 12.8 64l368 0c41.6 0 72.2 39.1 62.1 79.5L523.2 311.3C512.5 354 474.1 384 430 384l-217.6 0c-45.8 0-85.2-32.3-94.1-77.2L69.8 64 0 64 0 0zM147.8 128l33.3 166.3c3 15 16.1 25.7 31.4 25.7L430 320c14.7 0 27.5-10 31-24.2L503 128 147.8 128zM160 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm272-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  
    var faShoppingCart = faCartShopping;
  

  
  

  var faCheck = {
    prefix: 'fausb',
    iconName: 'check',
    icon: [
      512,
      512,
      [10003,10004],
      'f00c',
      
      'M493.5 128l-22.6 22.6-256 256c-12.5 12.5-32.8 12.5-45.3 0L41.6 278.6 19 256 64.3 210.7c1.3 1.3 44 44 128 128l233.4-233.4 22.6-22.6 45.3 45.3z'
      
    ]
  };

  

  
  

  var faCircleExclamation = {
    prefix: 'fausb',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ["exclamation-circle"],
      'f06a',
      
      'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-448a192 192 0 1 0 0 384 192 192 0 1 0 0-384zm0 328a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm28-120l-56 0 0-144 56 0 0 144z'
      
    ]
  };

  
    var faExclamationCircle = faCircleExclamation;
  

  
  

  var faCircleQuestion = {
    prefix: 'fausb',
    iconName: 'circle-question',
    icon: [
      512,
      512,
      [62108,"question-circle"],
      'f059',
      
      'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-448a192 192 0 1 0 0 384 192 192 0 1 0 0-384zm0 344a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-292c50.8 0 92 41.2 92 92s-41.2 92-92 92l-32 0 0-56 32 0c19.9 0 36-16.1 36-36s-16.1-36-36-36-36 16.1-36 36l-56 0c0-50.8 41.2-92 92-92z'
      
    ]
  };

  
    var faQuestionCircle = faCircleQuestion;
  

  
  

  var faCircleUser = {
    prefix: 'fausb',
    iconName: 'circle-user',
    icon: [
      512,
      512,
      [62142,"user-circle"],
      'f2bd',
      
      'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-104c-30.9 0-60.2 7-86.3 19.5 25.9 13.1 55.2 20.5 86.3 20.5 31 0 60.3-7.4 86.2-20.5-26.1-12.5-55.4-19.5-86.2-19.5zm0-344c-106 0-192 86-192 192 0 52.8 21.3 100.5 55.8 135.2 39.5-24.9 86.2-39.2 136.2-39.2s96.8 14.4 136.2 39.2C426.7 356.5 448 308.8 448 256 448 150 362 64 256 64zm0 256a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0-136a40 40 0 1 0 0 80 40 40 0 1 0 0-80z'
      
    ]
  };

  
    var faUserCircle = faCircleUser;
  

  
  

  var faClock = {
    prefix: 'fausb',
    iconName: 'clock',
    icon: [
      512,
      512,
      [128339,"clock-four"],
      'f017',
      
      'M448 256a192 192 0 1 0 -384 0 192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM284 144l0 84 96 0 0 56-124 0c-15.5 0-28-12.5-28-28l0-140 56 0 0 28z'
      
    ]
  };

  
    var faClockFour = faClock;
  

  
  

  var faFaceFrown = {
    prefix: 'fausb',
    iconName: 'face-frown',
    icon: [
      512,
      512,
      [9785,"frown"],
      'f119',
      
      'M448 256a192 192 0 1 0 -384 0 192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm176-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 328c-38.5 0-72.1 20.9-90.1 52l-41.5-24c26.2-45.4 75.4-76 131.6-76s105.4 30.6 131.7 76l-41.5 24c-18-31.1-51.6-52-90.1-52z'
      
    ]
  };

  
    var faFrown = faFaceFrown;
  

  
  

  var faHouse = {
    prefix: 'fausb',
    iconName: 'house',
    icon: [
      512,
      512,
      [63498,63500,127968,"home","home-alt","home-lg-alt"],
      'f015',
      
      'M448 192l-192-144-192 144 0 256 96 0 0-96c0-53 43-96 96-96s96 43 96 96l0 96 96 0 0-256zM216 448l80 0 0-96c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 96zm-56 64l-96 0c-35.3 0-64-28.7-64-64L0 192c0-20.1 9.5-39.1 25.6-51.2L256-32 486.4 140.8C502.5 152.9 512 171.9 512 192l0 256c0 35.3-28.7 64-64 64l-288 0z'
      
    ]
  };

  
    var faHome = faHouse;
  
    var faHomeAlt = faHouse;
  
    var faHomeLgAlt = faHouse;
  

  
  

  var faMagnifyingGlass = {
    prefix: 'fausb',
    iconName: 'magnifying-glass',
    icon: [
      576,
      512,
      [128269,"search"],
      'f002',
      
      'M256.3 0c123.7 0 224 100.3 224 224 0 50.3-16.6 96.7-44.6 134.1L557.5 480 512.3 525.3 390.4 403.4c-37.4 28-83.8 44.6-134.1 44.6-123.7 0-224-100.3-224-224S132.5 0 256.3 0zm0 64a160 160 0 1 0 0 320 160 160 0 1 0 0-320z'
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faMinus = {
    prefix: 'fausb',
    iconName: 'minus',
    icon: [
      448,
      512,
      [8211,8722,10134,"subtract"],
      'f068',
      
      'M445.6 288l-443.1 0 0-64 443.1 0 0 64z'
      
    ]
  };

  
    var faSubtract = faMinus;
  

  
  

  var faPlus = {
    prefix: 'fausb',
    iconName: 'plus',
    icon: [
      448,
      512,
      [10133,61543,"add"],
      '2b',
      
      'M256 224l192 0 0 64-192 0 0 192-64 0 0-192-192 0 0-64 192 0 0-192 64 0 0 192z'
      
    ]
  };

  
    var faAdd = faPlus;
  

  
  

  var faRocketLaunch = {
    prefix: 'fausb',
    iconName: 'rocket-launch',
    icon: [
      576,
      512,
      [128640],
      'e027',
      
      'M236.8 480.6l-54.1 54.1-45.2-45.2 54.1-54.1 45.2 45.3zm-64-64l-86.1 86.1-45.2-45.2 86.1-86.1 45.2 45.3zM544.1 147.3c0 51-17.4 99.5-48 138.4l0 66.3c0 79.5-64.5 144-144 144l-29.2 0-274.7-274.8 0-29.2c0-79.5 64.4-144 144-144l66.3 0C297.3 17.4 345.9 0 396.8 0l147.3 0 0 147.3zM323.7 406.3l25.7 25.7 2.7 0c44.2 0 80-35.8 80-80l0-10.7-108.4 65zM108.8 352.6l-54.1 54.1-45.2-45.2 54.1-54.1 45.2 45.3zM396.8 64c-52.7 0-101.8 25.9-131.5 68.9l-5.7 8.8-75.2 125.3 92.7 92.7 125.3-75.2c48.2-28.9 77.7-81 77.7-137.2l0-83.3-83.3 0zM368.1 224a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-176-112c-44.2 0-80 35.8-80 80l0 2.8 25.7 25.7 65-108.4-10.7 0z'
      
    ]
  };

  

  
  

  var faShareNodes = {
    prefix: 'fausb',
    iconName: 'share-nodes',
    icon: [
      512,
      512,
      ["share-alt"],
      'f1e0',
      
      'M456 96a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm56 0c0 53-43 96-96 96-25.9 0-49.4-10.2-66.6-26.9l-158.1 79c.5 3.9 .7 7.8 .7 11.9s-.2 8-.7 11.9l158.1 79c17.3-16.7 40.8-26.9 66.6-26.9 53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-4 .2-8 .7-11.9l-158.1-79C145.4 341.8 121.9 352 96 352 43 352 0 309 0 256s43-96 96-96c25.9 0 49.4 10.2 66.6 26.9l158.1-79c-.5-3.9-.7-7.8-.7-11.9 0-53 43-96 96-96s96 43 96 96zM136 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM416 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80z'
      
    ]
  };

  
    var faShareAlt = faShareNodes;
  

  
  

  var faTicket = {
    prefix: 'fausb',
    iconName: 'ticket',
    icon: [
      512,
      512,
      [127903],
      'f145',
      
      'M64 96l384 0 0 58.5c-33.7 21.3-56 58.8-56 101.5s22.3 80.3 56 101.5l0 58.5-384 0 0-58.5c33.7-21.3 56-58.8 56-101.5S97.7 175.7 64 154.5L64 96zM456 256c0-30.9 25.1-56 56-56l0-104c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 200c30.9 0 56 25.1 56 56S30.9 312 0 312L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-104c-30.9 0-56-25.1-56-56zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-32 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32-160a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faTrash = {
    prefix: 'fausb',
    iconName: 'trash',
    icon: [
      448,
      512,
      [],
      'f1f8',
      
      'M96 64c0-35.3 28.7-64 64-64L288 0c35.3 0 64 28.7 64 64l0 32 96 0 0 64-32 0 0 288c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-288-32 0 0-64 96 0 0-32zm64 32l128 0 0-32-128 0 0 32zm192 64l-256 0 0 288 256 0 0-288z'
      
    ]
  };

  

  
  

  var faUser = {
    prefix: 'fausb',
    iconName: 'user',
    icon: [
      448,
      512,
      [62144,62470,128100,"user-alt","user-large"],
      'f007',
      
      'M288 320c88.4 0 160 71.6 160 160l0 32-64 0 0-32c0-53-43-96-96-96l-128 0c-53 0-96 43-96 96l0 32-64 0 0-32c0-88.4 71.6-160 160-160l128 0zm-64-64a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm0-192a64 64 0 1 0 0 128 64 64 0 1 0 0-128z'
      
    ]
  };

  
    var faUserAlt = faUser;
  
    var faUserLarge = faUser;
  

  
  

  var faUsers = {
    prefix: 'fausb',
    iconName: 'users',
    icon: [
      640,
      512,
      [],
      'f0c0',
      
      'M288 320c88.4 0 160 71.6 160 160l0 32-64 0 0-32c0-53-43-96-96-96l-128 0c-53 0-96 43-96 96l0 32-64 0 0-32c0-88.4 71.6-160 160-160l128 0zm192 0c88.4 0 160 71.6 160 160l0 32-64 0 0-32c0-49.4-37.3-90.1-85.3-95.4-11.4-24.2-27-46.1-45.9-64.6l35.3 0zM224 256a128 128 0 1 1 0-256 128 128 0 1 1 0 256zM416 0c70.7 0 128 57.3 128 128S486.7 256 416 256c-15 0-29.4-2.6-42.8-7.4 13.8-17.1 24.8-36.5 32.1-57.6 3.5 .6 7 1 10.7 1 35.3 0 64-28.7 64-64s-28.7-64-64-64c-3.6 0-7.2 .4-10.7 .9-7.3-21.1-18.3-40.6-32.1-57.6 13.4-4.7 27.7-7.3 42.7-7.3zM224 64a64 64 0 1 0 0 128 64 64 0 1 0 0-128z'
      
    ]
  };

  

  
  

  var faXmark = {
    prefix: 'fausb',
    iconName: 'xmark',
    icon: [
      384,
      512,
      [215,10005,10006,10060,128473,"close","multiply","remove","times"],
      'f00d',
      
      'M365.5 128l-128 128 128 128-45.2 45.2-128-128-128 128-45.3-45.2 128-128-128-128 45.3-45.2 128 128 128-128 45.2 45.2z'
      
    ]
  };

  
    var faClose = faXmark;
  
    var faMultiply = faXmark;
  
    var faRemove = faXmark;
  
    var faTimes = faXmark;
  



export {

  faAngleDown,
  

  faAngleLeft,
  

  faAngleRight,
  

  faAngleUp,
  

  faArrowLeft,
  

  faArrowRight,
  

  faBars,
  
  faNavicon,
  

  faCalendar,
  

  faCartShopping,
  
  faShoppingCart,
  

  faCheck,
  

  faCircleExclamation,
  
  faExclamationCircle,
  

  faCircleQuestion,
  
  faQuestionCircle,
  

  faCircleUser,
  
  faUserCircle,
  

  faClock,
  
  faClockFour,
  

  faFaceFrown,
  
  faFrown,
  

  faHouse,
  
  faHome,
  
  faHomeAlt,
  
  faHomeLgAlt,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faMinus,
  
  faSubtract,
  

  faPlus,
  
  faAdd,
  

  faRocketLaunch,
  

  faShareNodes,
  
  faShareAlt,
  

  faTicket,
  

  faTrash,
  

  faUser,
  
  faUserAlt,
  
  faUserLarge,
  

  faUsers,
  

  faXmark,
  
  faClose,
  
  faMultiply,
  
  faRemove,
  
  faTimes,
  

};
